var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Content',{attrs:{"button-create-show":false},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('Table',{attrs:{"columns":_vm.columns,"options":_vm.columnsOptions,"method-fetch-data":_vm.methods.fetchData}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }